<template>
  <div>
    <!-- tabs for vendor & non-residents -->
    <v-tabs v-model="tab" v-if="lAction === 'view'"
    flat color="primary" dark
    grow height="40"
    fixed-tabs
    >
    <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`">
      {{ tabitem }}
    </v-tab>
  </v-tabs>
  <v-container v-if="lAction === 'view'" class="pa-2" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(tabitem, n) in tabitems" :key="n" :value="`tab-${n}`">
            <v-layout>
              <v-flex xs12 offset-sm3 class="mx-auto" v-if="tab === 'tab-0'">
                <v-card>
                  <v-card-title class="pa-2 grey lighten-4">
                    <div class="title grey--text">Registered vendors</div>
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <v-data-table
                    :headers="$vuetify.breakpoint.smAndUp ? vendorHeadSm:vendorHead"
                    :items="vendors"
                    hide-actions
                    disable-initial-sort
                    >
                    <template slot="items" slot-scope="props">
                      <tr @click="prepareUpdateVendor(props.item)">
                        <td>{{ props.item.vendor_name }}</td>
                        <td>{{ props.item.contact_phone }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_email }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_name }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.gst_no }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.vendor_status }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 offset-sm3 class="mx-auto" v-else>
              <v-card>
                <v-card-title class="pa-2 grey lighten-4">
                  <div class="title grey--text">Non-residents</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="$vuetify.breakpoint.smAndUp ? nonResHeadSm:nonResHead"
                  :items="nonResList"
                  hide-actions
                  >
                  <template slot="items" slot-scope="props">
                    <tr @click="prepareUpdateNonRes(props.item)">
                      <td>{{ props.item.non_res_name }}</td>
                      <td>{{ props.item.contact_phone }}</td>
                      <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_email }}</td>
                      <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.non_res_descrip }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed
      color="accent"
      @click.native="tab === 'tab-0' ? prepareCreateVendor() : prepareCreateNonRes()">
      <v-icon>add</v-icon>
    </v-btn>

    <v-btn small v-if="tab === 'tab-0'"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:315px;')"
    dark fab fixed
    color="accent"
    @click.native="prepareUpload">
    <v-icon>file_upload</v-icon>
  </v-btn>

</v-tabs-items>
</v-flex>
</v-layout>
</v-container>

<!-- 2. non res create/edit -->
<v-container v-if="lAction === 'create-nonres' || lAction === 'update-nonres'" class="pa-1" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 sm9 mx-auto>
      <v-form ref="nForm" @submit.prevent="saveChangesNonRes(lAction)">
        <v-card flat>
          <v-card-title class="title pb-0">
            {{ handy.startWithUpper(lAction.substring(0, lAction.indexOf('-'))) }} Non-resident
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                v-model="lNonRes.non_res_name"
                label="Non-resident name"
                maxlength="50"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                label="Phone"
                v-model="lNonRes.contact_phone"
                hide-details
                type="number"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                label="Service description"
                v-model="lNonRes.service_desc"
                hide-details
                :rules="[rules.required]"
                rows="2"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 class="pt-4">
                <span class="primary--text subheader pa-0">Other Information (Optional)</span>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                label="E-Mail"
                v-model="lNonRes.contact_email"
                maxlength="50"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                label="Address"
                v-model="lNonRes.address"
                maxlength="150"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="City"
                v-model="lNonRes.city"
                maxlength="25"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="PIN"
                v-model="lNonRes.pin"
                maxlength="10"
                hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.native="cancelChanges">Cancel</v-btn>
            <v-btn v-if="lAction === 'update-nonres'" @click.native="deleteNonRes">Delete</v-btn>
            <v-btn type="submit" color="accent">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- 3. vendor create/edit -->
<v-container v-if="lAction === 'create-vendor' || lAction === 'update-vendor'" class="pa-1" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 sm9 mx-auto>
      <v-form ref="vForm" @submit.prevent="saveChangesVendor(lAction)">
        <v-card flat>
          <v-card-title class="title pb-0">
            {{ handy.startWithUpper(lAction.substring(0, lAction.indexOf('-'))) }} Vendor
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-if="lAction === 'update-vendor'"
                v-model="lVendor.vendor_name"
                label="Vendor name"
                maxlength="50"
                :rules="[rules.required]"
                ></v-text-field>
                <v-combobox v-else
                v-model="lVendor.vendor"
                label="Vendor name"
                :items= "globalVendors"
                item-value="vendor_id"
                item-text="vendor_name"
                maxlength="50"
                clearable
                hint="Choose from common list or enter new if not found"
                persistent-hint
                @input="loadChosenVendor"
                ></v-combobox>
              </v-flex>
              <v-flex xs12 class="pt-4">
                <span class="primary--text subheader pa-0">Other Information (Optional)</span>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="Phone"
                v-model="lVendor.contact_phone"
                hide-details
                type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="EMail"
                v-model="lVendor.contact_email"
                maxlength="50"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="Contact person"
                v-model="lVendor.contact_name"
                maxlength="50"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="Designation"
                v-model="lVendor.contact_desig"
                maxlength="50"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                label="Address"
                v-model="lVendor.address"
                maxlength="150"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="City"
                v-model="lVendor.city"
                maxlength="25"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="PIN"
                v-model="lVendor.pin_code"
                maxlength="10"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="GST Number"
                v-model="lVendor.gst_no"
                maxlength="15"
                hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-dialog ref="dlgVendorDt"
                persistent v-model="dlgVendorDt"
                lazy max-width="290px"
                :return-value.sync="lVendor.vendor_since"
                >
                <v-text-field hide-details
                slot="activator" label="Vendor since"
                v-model="lVendor.vendor_since" append-icon="event"
                readonly clearable
                ></v-text-field>
                <v-date-picker v-model="lVendor.vendor_since" scrollable
                first-day-of-week="1"
                >
                <v-spacer></v-spacer>
                <v-btn flat @click="dlgVendorDt = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.dlgVendorDt.save(lVendor.vendor_since)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
        <v-btn v-if="lAction === 'update-vendor'" @click.native="deleteVendor">Delete</v-btn>
        <v-btn type="submit" color="accent">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-flex>
</v-layout>
</v-container>

<!-- Upload File -->
<v-container v-if="lAction === 'upload'" class="pa-2" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Vendor List
        </v-card-title>
        <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">In just 4 steps</div>
        <v-card-text class="subheading">
          <v-layout row wrap>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 1</v-chip>
              <span>Download template</span>
              <span style="float:right;">
                <form method="get" action="../static/files/Smartility_Vendor_List_Template.xlsx">
                  <v-btn type="submit" class="mt-0 mb-0" small><v-icon>file_download</v-icon></v-btn>
                </form>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 2</v-chip>
              <span>Fill-in details as guided in template</span>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 3</v-chip>
              <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
              <span class="caption grey--text pl-4 ml-4">
                <span class="ml-4">Go with OK/Yes when prompted while saving</span>
              </span>
            </span>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 4</v-chip>
            <span>Upload the CSV file</span>
            <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>file_upload</v-icon></v-btn></span>
            <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
          </v-flex>
          <v-flex xs12>
            <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">Integra takes care of rest</div>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 5</v-chip>
            <span>Validate your information</span>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 6</v-chip>
            <span>Create Vendor List</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0 pr-4">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>
<!-- validate file -->
<v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Vendor List
        </v-card-title>
        <v-card-text class="text-xs-center pl-2 pr-2">
          <v-layout row wrap>
            <v-flex xs12 md9 mx-auto>
              <v-layout row wrap>
                <v-flex xs12 class="info--text mb-2">
                  <span v-if="validateInProgress">Loading and validating the file...</span>
                  <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">check</v-icon></span>
                  <span v-if="!validFile">File validation is failed <v-icon class="error--text">close</v-icon></span>
                  <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                  <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                  <span v-if="!totFail && !loadInProgress">Vendor list upload was successfull<v-icon class="success--text">check</v-icon></span>
                  <span v-if="!totLoaded && totFail && !loadInProgress"><br />Vendor list upload has failed<v-icon class="error--text">close</v-icon></span>
                  <span v-if="totLoaded && totFail && !loadInProgress"><br />Vendor list upload partially failed<v-icon class="warning--text">close</v-icon></span>
                  <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="info"
                  :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totValid : recsLoaded.length }}
                </v-progress-circular>
                <br/><div class="caption grey--text">Records</div>
              </v-flex>
              <v-flex xs4 v-if="totRecs">
                <v-progress-circular color="success"
                :value="(totValid/totRecs*100)"
                :size="50" :width="7">
                {{ readyForLoad ? totLoaded : totValid }}
              </v-progress-circular>
              <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
            </v-flex>
            <v-flex xs4 v-if="totRecs">
              <v-progress-circular color="error"
              :value="(totInvalid/totRecs*100)"
              :size="50" :width="7">
              {{ readyForLoad ? totFail : totInvalid }}
            </v-progress-circular>
            <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
          </v-flex>
          <v-flex xs12>
            <v-btn small @click.native="lAction='upload'">Close</v-btn>
            <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadVendor" :disabled="beingSaved">Process the valid records</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="mt-2">
        <v-data-table
        :headers="loadHeadSm"
        :items="recsLoaded"
        hide-actions
        class="elevation-3 text-xs-left"
        disable-initial-sort
        >
        <template slot="items" slot-scope="props">
          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
            <td>{{ props.item.vendor_name }}</td>
            <td>{{ props.item.contact_phone }}</td>
            <td>{{ props.item.contact_email }}</td>
            <td>{{ props.item.contact_person }}</td>
            <td>{{ props.item.contact_desig }}</td>
            <td>{{ props.item.address }}</td>
            <td>{{ props.item.city }}</td>
            <td>{{ props.item.pin_code }}</td>
            <td>{{ props.item.gst_no }}</td>
            <td>{{ props.item.vendor_since }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions class="pt-0" v-if="false">
  <v-spacer></v-spacer>
  <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<div v-if="load" style="position:absolute; top:20%; left:50%">
  <v-progress-circular indeterminate color="primary"></v-progress-circular>
</div>

</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      search: '',
      pagination: {}, // workaround to update line items in update mode
      // component specific
      tab: 'tab-0',
      tabitems: ['vendor', 'non-resident'],
      lNonRes: {},
      nonResList: [],
      vendors: [],
      globalVendors: [],
      nonResHead: [
        { text: 'Name', value: 'non_res_name' },
        { text: 'Phone', value: 'contact_phone' }
      ],
      nonResHeadSm: [
        { text: 'Name', value: 'non_res_name' },
        { text: 'Phone', value: 'contact_phone' },
        { text: 'E-Mail', value: 'contact_email' },
        { text: 'Service Description', value: 'non_res_descrip' }
      ],
      vendorHead: [
        { text: 'Vendor Name', value: 'vendor_name' },
        { text: 'Phone', value: 'contact_phone' }
      ],
      vendorHeadSm: [
        { text: 'Vendor Name', value: 'vendor_name' },
        { text: 'Phone', value: 'contact_phone' },
        { text: 'E-Mail', value: 'contact_email' },
        { text: 'Contact Person', value: 'contact_name' },
        { text: 'GST No.', value: 'gst_no' },
        { text: 'Status', value: 'vendor_status' }
      ],
      lVendor: {},
      dlgVendorDt: false,
      // file upload
      loadHeadSm: [
        { text: 'Vendor Name', value: 'vendor_name' },
        { text: 'Phone', value: 'contact_phone' },
        { text: 'Email', value: 'contact_email' },
        { text: 'Contact Person', value: 'contact_name' },
        { text: 'Designation', value: 'contact_desig' },
        { text: 'Address', value: 'address' },
        { text: 'City', value: 'city' },
        { text: 'PIN', value: 'pin_code' },
        { text: 'GST Number', value: 'gst_no' },
        { text: 'Vendor Since', value: 'vendor_since' }
      ],
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      reqHeaders: ['Vendor Name', 'Phone', 'Email', 'Contact Person', 'Designation', 'Address', 'City', 'PIN', 'GST Number', 'Vendor Since'],
      colNames: [
        {col_name: 'vendor_name', is_required: true},
        {col_name: 'contact_phone', is_required: false},
        {col_name: 'contact_email', is_required: false},
        {col_name: 'contact_person', is_required: false},
        {col_name: 'contact_desig', is_required: false},
        {col_name: 'address', is_required: false},
        {col_name: 'city', is_required: false},
        {col_name: 'pin_code', is_required: false},
        {col_name: 'gst_no', is_required: false},
        {col_name: 'vendor_since', is_required: false}
      ]
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  created () {
    // load recent expenses and pre-req
    this.loadVendor()
    this.loadNonRes()
    this.lAction = 'view'
  },
  mounted () {
    this.loading()
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
      setTimeout(() => {
        this.load = false
      }, 500)
    },
    getEmptyNonRes () {
      var emptyNonRes = {
        comm_id: config.COMM_ID,
        non_res_name: '',
        contact_phone: '',
        service_desc: ''
      }
      return emptyNonRes
    },
    getEmptyVendor () {
      var emptyVendor = {
        comm_id: config.COMM_ID,
        vendor_since: this.today
      }
      return emptyVendor
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    deleteNonRes () {
      // confirm
      if (confirm('Sure, you want to delete the non-resident "' + this.lNonRes.non_res_name + '"?')) {
        // delete
        this.saveChangesNonRes('delete-nonres')
      }
    },
    deleteVendor () {
      // confirm
      if (confirm('Sure, you want to delete the vendor "' + this.lVendor.vendor_name + '"?')) {
        // delete
        this.saveChangesVendor('delete-vendor')
      }
    },
    prepareCreateNonRes () {
      this.lNonRes = this.getEmptyNonRes()
      this.lAction = 'create-nonres'
    },
    prepareCreateVendor () {
      this.loadGlobalVendor()
      this.lVendor = this.getEmptyVendor()
      this.lAction = 'create-vendor'
    },
    prepareUpdateNonRes (curNonRes) {
      this.lNonRes = Object.assign({}, curNonRes) // keep the original object safely before changes
      this.lAction = 'update-nonres'
    },
    loadChosenVendor () {
      var idx = this.globalVendors.findIndex(rec => this.lVendor.vendor && rec.vendor_id === this.lVendor.vendor.vendor_id)
      if (idx >= 0) {
        this.lVendor = Object.assign({}, this.globalVendors[idx])
        this.lVendor.comm_id = config.COMM_ID
        this.lVendor.vendor_since = this.today
      }
    },
    prepareUpdateVendor (curVendor) {
      this.loadGlobalVendor()
      this.lVendor = Object.assign({}, curVendor) // keep the original object safely before changes
      this.lVendor.vendor = this.lVendor.vendor_name
      this.lAction = 'update-vendor'
      if (this.lVendor.vendor_since) {
        this.lVendor.vendor_since = handy.formatDBDate(this.lVendor.vendor_since)
      }
    },
    saveChangesNonRes (curAction) {
      // validate and save Changes
      if (curAction === 'create-nonres' || curAction === 'update-nonres') {
        if (!this.$refs.nForm.validate()) {
          return
        }
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/non-res/' + curAction, this.lNonRes)
      .then(response => {
        // refresh list in front end
        this.loadNonRes()
        this.beingSaved = false
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    saveChangesVendor (curAction) {
      // validate and save Changes
      if (curAction === 'create-vendor' || curAction === 'update-vendor') {
        if (!this.$refs.vForm.validate()) {
          return
        }
        if (!this.lVendor.vendor && !this.lVendor.vendor_id) {
          this.msg('Choose or enter vendor name', true)
          return
        } else {
          if (!this.lVendor.vendor_id) {
            this.lVendor.vendor_name = this.lVendor.vendor
          }
        }
      }
      this.lVendor.vendor_since = this.lVendor.vendor_since ? handy.formatDBDate(this.lVendor.vendor_since) : handy.formatDBDate(new Date())
      this.beingSaved = true
      this.axios.post(config.API_URL + '/vendor/' + curAction, this.lVendor)
      .then(response => {
        // refresh list in front end
        this.loadVendor()
        this.loading()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    loadNonRes () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.nonResList = []
      this.axios.get(config.API_URL + '/getNonResByCommId/', qry)
      .then(response => {
        this.nonResList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadVendor () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.vendors = []
      this.axios.get(config.API_URL + '/getVendorByCommId/', qry)
      .then(response => {
        this.vendors = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadGlobalVendor () {
      this.globalVendors = []
      this.axios.get(config.API_URL + '/getGlobalVendors/')
      .then(response => {
        this.globalVendors = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareUpload () {
      this.lAction = 'upload'
    },
    promptUpload () {
      this.$refs.ipFile.click()
    },
    validateFile () {
      this.lAction = 'validate'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0
      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqHeaders.length; i++) {
          if (headers[i] !== this.reqHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            for (var c = 0; c < this.colNames.length; c++) {
              if (this.colNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                res['error'] += this.reqHeaders[c] + ' is empty; '
              } else {
                res[this.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
              }
            }
            this.recsLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
            if (res['vendor_since']) {
              res['vendor_since'] = handy.formatDBDate(res['vendor_since'])
            } else {
              res['vendor_since'] = handy.formatDBDate(new Date())
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    showError (err) {
      this.msg(err, 2)
    },
    async uploadVendor () {
      // create vendor List one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = ''
      for (var i = 0; i < this.recsLoaded.length; i++) {
        curRec = this.recsLoaded[i]
        if (!this.recsLoaded[i].error) { // process only valid records
          // fill-in gaps
          this.recsLoaded[i].comm_id = config.COMM_ID
          // create record
          await this.axios.post(config.API_URL + '/vendor/create-vendor', this.recsLoaded[i])
          .then(response => {
            curRec.load_status = 'Loaded'
            this.totLoaded++
          })
          .catch(err => {
            curRec.error = err.response.data
            curRec.load_status = 'Failed'
            this.totFail++
          })
          this.$forceUpdate()
        }
      } // for every record
      if (this.totLoaded) {
        this.loadVendor()
        if (!this.totFail) {
          this.lAction = 'view'
        }
      }
      this.loadInProgress = false
      this.beingSaved = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// Vendor.vue?efa32aa2